/* Free Shipping Progress Bar Script */
(function () {
  const THRESHOLD = 1; // $100.00 in cents
  
  // Update free shipping progress bar
  function updateFreeShippingProgress(cartTotal) {
    const progressBar = document.querySelector('.js-free-shipping-bar');
    const message = document.querySelector('.cart-free-shipping__message');
    
    if (!progressBar) {
      console.log('Free shipping progress bar not found');
      return;
    }
    
    const remaining = THRESHOLD - cartTotal;
    let percentage = Math.round((cartTotal / THRESHOLD) * 100);
    
    // Cap at 100%
    if (percentage > 100) {
      percentage = 100;
    }
    
    console.log('Updating progress bar:', { cartTotal, percentage, remaining });
    
    // Update progress bar with explicit width and styles
    progressBar.style.width = percentage + '%';
    progressBar.style.background = '#289926';
    progressBar.style.display = 'block';
    progressBar.setAttribute('data-percentage', percentage);
    
    // Update message
    if (message && remaining > 0) {
      const dollars = (remaining / 100).toFixed(2);
      message.innerHTML = `You're <strong>$${dollars} USD</strong> away from <strong>Free Shipping!</strong>`;
      message.classList.remove('cart-free-shipping__message--unlocked');
    } else if (message && remaining <= 0) {
      message.innerHTML = `
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" class="cart-free-shipping__icon">
          <rect width="20" height="20" rx="4" fill="currentColor"/>
          <path d="M6 10L9 13L14 7" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        You've unlocked Free Shipping!
      `;
      message.classList.add('cart-free-shipping__message--unlocked');
    }
  }

  // Initialize on page load
  function init() {
    const container = document.querySelector('.cart-free-shipping');
    if (container) {
      const cartTotal = parseInt(container.getAttribute('data-cart-total')) || 0;
      console.log('Initializing free shipping bar with cart total:', cartTotal);
      
      // Small delay to ensure DOM is ready
      setTimeout(() => {
        updateFreeShippingProgress(cartTotal);
      }, 100);
    }
  }

  // Run on different load events
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Listen for cart updates
  document.addEventListener('cart:updated', function(event) {
    if (event.detail && event.detail.cart) {
      updateFreeShippingProgress(event.detail.cart.total_price);
    }
  });

  // Expose function globally
  window.updateFreeShippingProgress = updateFreeShippingProgress;
})();

